<template>
  <div>
    <b-modal
      ref="modal-subdivision"
      centered
      no-close-on-backdrop
      header-bg-variant="light"
      footer-bg-variant="light"
      size="xl"
      button-size="sm"
    >
      <template #modal-header="">
        <h5>FILE OF SUBDIVISIONS</h5>
        <b-button
          @click="addSubdivision()"
          class="btnAdd"
          size="sm"
          variant="dark"
        >
          New
        </b-button>
      </template>

      <b-tabs
        v-model="activeTab"
        small
        pills
        active-nav-item-class="font-weight-bold text-white"
      >
        <b-tab
          v-for="(division, index) in divisiones"
          :active="index === activeTab"
          :key="division.id_division"
          @click="id_division = division.id_division"
        >
          <template v-slot:title>
            {{ division.nombre }}
            <b-badge variant="danger">{{
              countsDiv[division.id_division]
            }}</b-badge>
          </template>
        </b-tab>
      </b-tabs>
      <hr />
      <b-row>
        <b-col lg="6" class="my-1">
          <b-form-group
            label="Filter"
            label-for="filter-input"
            label-cols-sm="2"
            label-align-sm="left"
            label-size="sm"
            class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-input
                id="filter-input"
                v-model="filter"
                type="search"
                placeholder="Type to Search"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col lg="6" class="my-1">
          <b-tabs small>
            <b-button
              v-for="ruta in rutasFiltradas"
              :key="ruta.id_ruta"
              v-bind:style="{
                width: '50px',
                height: '30px',
                background: ruta.color,
                color: 'black',
              }"
            >
              <!-- <template v-slot:title>{{ ruta.color }} </template> -->
              <b-badge variant="info"
                >{{ countsRut[ruta.id_division][ruta.id_ruta] }}
              </b-badge>
            </b-button>
          </b-tabs>
        </b-col>
      </b-row>

      <b-table
        hover
        striped
        select-mode="single"
        small
        sticky-header
        :items="itemsFiltrados"
        :fields="fields"
        :busy="isBusy"
        :filter="filter"
        head-variant="dark"
        class="mt-3"
        bordered
        style="max-height: 500px"
        ref="selectableTable"
        selectable
        @filtered="onFiltered"
      >
        <template #cell(tipo_subd)="data">
          <b class="text-info">{{ categorias[data.value].name }}</b>
        </template>

        <template #cell(color)="data">
          <button
            v-bind:style="{
              width: '100%',
              height: '100%',
              background: data.item.color,
              color: 'black',
            }"
          >
            <span v-if="data.item.color == 'white'">n/a</span>
            <template v-else>{{ data.item.color }}</template>
          </button>
        </template>

        <template #cell(delete)="row">
          <b-button
            variant="outline-danger"
            @click="promptDelete(row.item, row.index)"
          >
            <b-icon icon="trash"></b-icon>
          </b-button>
        </template>

        <template #cell(edit)="row">
          <b-button
            @click="editSubdivision(row.item)"
            variant="outline-success"
          >
            <b-icon icon="pencil"></b-icon>
          </b-button>
        </template>

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
      </b-table>

      <template #modal-footer="{}">
        <div class="w-100">
          <!-- <p class="float-left">
            <strong> Count: {{ totalRows }}</strong>
          </p> -->
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button
            class="float-left"
            size="sm"
            variant="secondary"
            @click="goHome()"
          >
            go Back
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal
      v-model="modalEditShow"
      no-close-on-backdrop
      header-bg-variant="light"
      footer-bg-variant="light"
      size="lg"
      button-size="sm"
      centered
    >
      <template #modal-header="">
        <h5>Edit Subdivision</h5>
      </template>
      <b-card bg-variant="light">
        <b-form-group label-cols-lg="1" class="mb-0">
          <b-form-group
            label="Name:"
            label-for="name"
            label-cols-sm="2"
            label-align-sm="right"
          >
            <b-form-input
              id="name"
              v-model="actualSubdivision.nombre"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            label="Address"
            label-for="address"
            label-cols-sm="2"
            label-align-sm="right"
          >
            <b-form-input
              id="address"
              v-model="actualSubdivision.direccion"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            label="Route:"
            label-for="route"
            label-cols-sm="2"
            label-align-sm="right"
          >
            <b-form-select
              v-model="routeSelected"
              :options="routeOptions"
              size="sm"
              class="mt-3"
            ></b-form-select>
          </b-form-group>
        </b-form-group>
      </b-card>
      <template #modal-footer="{}">
        <div class="w-100">
          <b-button
            class="float-left"
            size="sm"
            variant="secondary"
            @click="modalEditShow = !modalEditShow"
          >
            go Back
          </b-button>
          <b-button
            class="float-right"
            size="sm"
            variant="success"
            @click="saveSubdivision()"
          >
            Save
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      v-model="modalAddShow"
      no-close-on-backdrop
      header-bg-variant="light"
      footer-bg-variant="light"
      size="lg"
      button-size="sm"
      centered
    >
      <template #modal-header="">
        <h5>Add New Subdivision</h5>
      </template>
      <b-card bg-variant="light">
        <b-form-group label-cols-lg="1" class="mb-0">
          <b-form-group
            label="Name:"
            label-for="name"
            label-cols-sm="2"
            label-align-sm="right"
          >
            <b-form-input
              id="name"
              v-model="newSubdivision.nombre"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            label="Address"
            label-for="address"
            label-cols-sm="2"
            label-align-sm="right"
          >
            <b-form-input
              id="address"
              v-model="newSubdivision.direccion"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            label="Route:"
            label-for="route"
            label-cols-sm="2"
            label-align-sm="right"
          >
            <b-form-select
              v-model="routeSelected"
              :options="routeOptions"
              size="sm"
              class="mt-3"
            ></b-form-select>
          </b-form-group>
        </b-form-group>
      </b-card>
      <template #modal-footer="{}">
        <div class="w-100">
          <b-button
            class="float-left"
            size="sm"
            variant="secondary"
            @click="modalAddShow = !modalAddShow"
          >
            go Back
          </b-button>
          <b-button
            class="float-right"
            size="sm"
            variant="success"
            @click="showMsgSave()"
          >
            Save
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "SubDivisions",
  data: function () {
    return {
      url: "https://www.imandrades.com/apiIMA/subdiv.php?action=",
      urlD: "https://www.imandrades.com/apiIMA/divisiones.php?action=",
      urlr: "https://www.imandrades.com/apiIMA/rutas.php?action=",
      tarjetas: {},
      isBusy: false,
      fields: [
        { key: "nombre", label: "Sub-Division", class: "text-left" },
        { key: "tipo_subd", label: "Category", class: "text-center" },
        { key: "color", label: "Route", class: "text-center" },
        { key: "city", label: "City", class: "text-left" },
        { key: "delete", class: "text-center" },
        { key: "edit", class: "text-center" },
      ],
      modalEditShow: false,
      modalAddShow: false,
      filter: "",
      items: [],
      colores: [],
      optionColors: [],
      routes: [],
      divisiones: [],
      subdivisiones: [],
      counts: [],
      countsDiv: [],
      countsRut: [],
      id_division: 0,
      activeTab: 99,
      actualSubdivision: {},
      newSubdivision: {},
      totalRows: 0,
      selected: [],
      confirmDelete: "",
      currentDivision: "GEORGIA",
      categorySelected: "0",
      categorias: [
        { item: "0", name: "Client" },
        { item: "1", name: "Landfill" },
        { item: "2", name: "Company" },
        { item: "3", name: "Fuel Station" },
      ],
      routeSelected: "A",
      routeOptions: [
        { value: "A", text: "All" },
        { value: -1, text: "n/a" },
      ],
    };
  },
  mounted() {
    this.$refs["modal-subdivision"].show();
    this.id_division = localStorage.getItem("id_division");
    this.actualDivision = localStorage.getItem("division");
    this.leerDivisiones();
    this.leerRutas();
    this.leerSubdivisiones();
    this.leerColores();
  },
  computed: {
    itemsFiltrados: function () {
      return this.items.filter((it) => {
        return it.id_division == this.id_division;
      });
    },
    rutasFiltradas: function () {
      return this.routes.filter((it) => {
        return it.id_division == this.id_division;
      });
    },
  },
  methods: {
    mayusculas(value) {
      return value.toUpperCase();
    },
    leerColores: async function () {
      try {
        let respuesta = await axios.get(this.urlr, {
          params: {
            action: "getColores",
          },
        });
        this.colores = respuesta.data.colores;
        this.colores.forEach((color) => {
          this.optionColors.push({
            value: color,
            text: color,
          });
        });
      } catch (error) {
        console.log("Error Reading Colors");
      }
    },
    leerSubdivisiones: async function () {
      this.isBusy = true;
      try {
        let respuesta = await axios.get(this.url + "getSubd");
        this.subdivisiones = respuesta.data.subdivisiones;
        this.items = this.subdivisiones;
        this.isBusy = false;
        this.countsDiv = respuesta.data.countsDiv;
        this.countsRut = respuesta.data.countsRut;
        console.log(this.countsRut);
      } catch (error) {
        console.log("Error Leyendo Subdivisiones");
      }
    },
    leerDivisiones: async function () {
      try {
        let respuesta = await axios.get(this.urlD + "getDivisiones");
        this.divisiones = respuesta.data.divisiones;
        this.activeTab = this.divisiones
          .map(function (d) {
            return d.id_division;
          })
          .indexOf(this.id_division);
      } catch (error) {
        console.log("Error Leyendo Divisiones");
      }
    },
    leerRutas: async function () {
      console.log("voy a leer rutas");
      try {
        let respuesta = await axios.get(this.urlr, {
          params: {
            action: "getRutas",
          },
        });

        this.routes = respuesta.data.rutas;
        console.log("RUTAS: ", this.routes);
      } catch (error) {
        console.log("Error Leyendo routes");
      }
    },
    saveSubdivision() {},
    goHome() {
      this.$refs["modal-subdivision"].hide();
      this.$router.push("menuDesktop");
    },
    /* onRowSelected() {
      this.selected = items;
      console.log(this.selected);
    }, */
    promptDelete(item, index) {
      console.log("ITEM:", item);
      console.log("INDEX:", index);
      this.confirmDelete = "";
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to delete Subdivision '" +
            item.nombre +
            "'",
          {
            title: "Delete Subdivision",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: true,
            centered: true,
          }
        )
        .then((value) => {
          this.confirmDelete = value;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    editSubdivision(item) {
      this.actualSubdivision = item;
      this.modalEditShow = true;
    },
    addSubdivision() {
      this.newSubdivision = {};
      this.modalAddShow = true;
    },
    showMsgSave() {
      this.boxTwo = "";
      this.modalEditShow = false;
      this.modalAddShow = false;
      this.$bvModal
        .msgBoxOk("Data was submitted successfully", {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true,
        })
        .then(() => {})
        .catch(() => {});
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>


<style scoped>
.btnAdd {
  display: block;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.btnAdd:hover {
  transform: scale(1.2);
}
.btnRoute {
  float: left;
  padding: 3px;
}
.btnRoute:active,
.btnRoute:hover {
  transform: scale(1.05);
}
.btnText {
  color: rgb(150, 146, 146);
}
.row {
  height: 45px;
}
</style>

